export default function FormatCodigo(number) {
  let tamanho = String(number).length;
  let zeros = String('0').repeat(6 - tamanho);
  
  return zeros + number;

}
